import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import classnames from 'classnames'

import * as styles from './index.module.less'

interface dataProp {
  buttonText?: string
  desc?: string
  link?: string
  title?: string
  en_title?: string
  bg?: any
  hover_bg?: any
  arrow_icon?: any
}
interface CommunityProps {
  data?: dataProp[]
}

export const Community: React.FC<CommunityProps> = ({ data }) => {
  const [current, setCurrent] = useState(0)
  const oneItem = data && data.length < 2
  return (
    <>
      <ul
        className={classnames('hidden lg:flex w-[1200px] mx-auto my-[100px]', {
          ['w-auto']: oneItem,
          ['justify-center']: oneItem,
        })}
      >
        {data?.map((item, index) => (
          <li
            className={classnames(
              'w-[256px] mr-[32px] shadow-[0_2px_10px_0_rgb(193,208,211,42%)] rounded-[4px] h-[288px] transition-all duration-200',
              { 'w-[916px]': index === current },
            )}
            key={item.title}
            style={{ background: 'linear-gradient(303deg, #DBFFF5 0%, #FFFFFF 100%)' }}
            onMouseOver={() => setCurrent(index)}
            onClick={() => window.open(item.link)}
          >
            <div
              className="py-[38px] cursor-pointer px-[26px] w-full h-full bg-cover bg-no-repeat rounded-[4px]"
              style={{
                backgroundImage:
                  index === current
                    ? `url(${item?.hover_bg?.publicURL ?? item?.hover_bg})`
                    : `url(${item?.bg?.publicURL ?? item?.bg})`,
              }}
            >
              <p className="text-[#1F2D3D] text-[18px] font-medium">{item.title}</p>
              <p className="text-[#475669] text-[14px] mt-[2px]">{item.en_title}</p>
              <p
                className={classnames('text-[#475669] text-[14px] mt-[30px] w-[539px] h-[40px] opacity-0', {
                  '!opacity-100': index === current,
                  [styles.descToOpacity]: index !== current,
                  [styles.descAppear]: index === current,
                })}
              >
                {item.desc}
              </p>
              <a
                className={classnames(
                  'flex items-center text-[#04CB94] inline-block text-[14px] mt-[60px] opacity-0 transition-all duration-200',
                  { '!opacity-100': index === current },
                )}
                href={item.link}
                target="_blank"
              >
                <span className="mr-[7px]">{item?.buttonText}</span>
                <img src={item?.arrow_icon?.publicURL ?? item?.arrow_icon} />
                <img src={item?.arrow_icon?.publicURL ?? item?.arrow_icon} />
              </a>
            </div>
          </li>
        ))}
      </ul>
      <div
        className={classnames('block lg:hidden bg-[#F9FAFC] my-[5rem] ml-[1rem]', styles.Community)}
        style={{ margin: oneItem ? '4rem 1rem 6rem 1rem' : '' }}
      >
        <Swiper
          className={styles.swiperStyle}
          slidesPerView={oneItem ? undefined : 'auto'}
          pagination={{ type: 'bullets' }}
          spaceBetween={oneItem ? 0 : 30}
          style={{ height: oneItem ? 'auto' : '' }}
        >
          {data?.map((item) => (
            <SwiperSlide
              style={{
                margin: oneItem ? '0' : '1rem 2rem 1rem 1rem',
                width: oneItem ? '100%' : undefined,
              }}
              key={item.title}
            >
              <div
                className={classnames('h-[26.2rem] pt-[2.8rem] px-[1.3rem]')}
                style={{
                  margin: oneItem ? '1rem' : '',
                  height: oneItem ? '17.6rem' : '',
                  background: 'linear-gradient(303deg, #DBFFF5 0%, #FFFFFF 100%)',
                  boxShadow: '0px 2px 10px 0px rgba(193,208,211,0.42)',
                  borderRadius: '4px',
                }}
              >
                <div
                  className="w-full h-full bg-cover bg-no-repeat"
                  style={{ backgroundImage: `url(${item?.bg?.publicURL ?? item?.bg})` }}
                >
                  <p className="text-[#1F2D3D] text-[18px] font-medium">{item.title}</p>
                  <p className="text-[#475669] text-[14px] mt-[2px]">{item.en_title}</p>
                  <a
                    className={classnames('flex items-center text-[#04CB94] inline-block text-[14px] mt-[18px]')}
                    href={item.link}
                  >
                    <span className="mr-[4px]">{item?.buttonText}</span>
                    <img src={item?.arrow_icon?.publicURL ?? item?.arrow_icon} />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  )
}

export default Community
